export default __webpack_public_path__ + "static/media/home-2.30061290.png";